---
fr:
  contract:
    active: Actif
    counterpart: Contrepartie
    end_date: Date de fin du contrat
    errors:
      ownership_unscaled_on_shadow: Les contrats de tarif de rachat et de couverture ne peuvent pas être associés à une centrale fantôme, qui n'a pas de part de propriété pour répartir la production partagée.
    open_ended: Contrat à durée indéterminée
    power_plant: Centrale électrique
    power_plants: Centrales électriques
    start_date: Date de début du contrat
    type: Type de contrat
